import script from "./FilterContact.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterContact.vue?vue&type=script&setup=true&lang=ts"

import "./FilterContact.vue?vue&type=style&index=0&id=2c6769f0&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6769f0"]])

export default __exports__